<script setup lang="ts">
import {reactive, ref} from "vue";
import {SectionService} from "@/api/api.ts";
import {ElNotification} from "element-plus";
import {StudyUser} from "@/types";
import {TimeFormatter} from "@/utils/common.ts";

const loading = ref(false)
const isShowing = ref(false)
const userList = ref<StudyUser[]>([])
const pagination = reactive({
  page: 1,
  pageSize: 10,
  total: 0,
})

// 章节id
let sectionId = 0
let courseType = 0
// 用户手机号搜索
const phone = ref('')
// 用户昵称搜索
const content = ref('')

const getStudySectionList = async () => {
  try {
    loading.value = true
    const {data} = await SectionService.getStudySectionList({
      page: pagination.page,
      pageSize: pagination.pageSize,
      section_id: sectionId,
      course_type: courseType,
      phone: phone.value,
      content: content.value,
    })
    if (data.code === 200) {
      if (data.data) {
        userList.value = data.data.list
        pagination.total = data.data.count
        pagination.page = data.data.page
        pagination.pageSize = data.data.pageSize
      } else {
        userList.value = []
      }
    } else {
      ElNotification.error({
        message: data.msg,
      })
    }
  } catch (error) {
    console.warn(error)
  } finally {
    loading.value = false
  }
}

const onSearch = () => {
  pagination.page = 1
  getStudySectionList()
}

const onReset = () => {
  phone.value = ''
  content.value = ""
  onSearch()
}

const onPageSizeChange = (pageSize: number) => {
  pagination.pageSize = pageSize
  getStudySectionList()
}

const onPageChange = (page: number) => {
  pagination.page = page
  getStudySectionList()
}

const show = (_sectionId: number, type: number) => {
  sectionId = _sectionId
  courseType = type
  phone.value = ""
  content.value = ""
  isShowing.value = true
  onSearch()
}

const hide = () => {
  isShowing.value = false
}

const emit = defineEmits(["close"])

const onClose = () => {
  emit("close")
}

defineExpose({
  show, hide
})
</script>

<template>
  <el-dialog title="学习记录" v-model="isShowing" @close="onClose" width="60%" align-center>
    <div class="flex">
      <el-input v-model="phone" placeholder="请输入手机号" style="width: 12rem" class="mr-1rem"></el-input>
      <el-input v-model="content" placeholder="请输入昵称" style="width: 12rem" class="mr-1rem"></el-input>
      <el-button type="primary" @click="onSearch">搜索</el-button>
      <el-button type="primary" @click="onReset" plain>重置</el-button>
    </div>
    <el-table :data="userList" class="mt-1rem" v-loading="loading">
      <el-table-column prop="id" label="ID"></el-table-column>
      <el-table-column prop="user_id" label="用户ID" @change="onSearch"></el-table-column>
      <el-table-column prop="user_name" label="用户名" @change="onSearch"></el-table-column>
      <el-table-column prop="mobile" label="手机号"></el-table-column>
      <el-table-column prop="count" label="学习次数"></el-table-column>
      <el-table-column prop="time" label="最近一次学习时间" v-if="courseType === 1">
        <template #default="scope">
          {{ TimeFormatter.formatTime(scope.row.time * 1000) }}
        </template>
      </el-table-column>
      <el-table-column prop="plan" label="最大学习进度" v-if="courseType === 2">
        <template #default="scope">
          {{ scope.row.plan * 1000 }}%
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
        :page-size="pagination.pageSize"
        :current-page="pagination.page"
        :total="pagination.total"
        @size-change="onPageSizeChange"
        @current-change="onPageChange"
        class="mt-1rem"
        layout="prev, pager, next, total, ->, jumper">
    </el-pagination>
  </el-dialog>

</template>

<style scoped>
</style>
